import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetInsurerQuery } from '../../../api/queries/getInsurer';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import InsurerDetailsInnerPage from './InsurerDetailsInnerPage';

const InsurerDetailsPage = () => {
    const { insurerId } = useParams<{ insurerId: string }>();

    const { data, loading } = useGetInsurerQuery({
        fetchPolicy: 'network-only',
        variables: { id: insurerId },
    });

    const insurer = data?.insurer;

    if (!insurer && loading) {
        return <LoadingElement />;
    }

    if (!insurer) {
        return <NotFoundResult />;
    }

    return <InsurerDetailsInnerPage insurer={insurer} />;
};

export default InsurerDetailsPage;
